import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { OnDestroyHookDirective } from '../../../shared/hooks';
import { Store } from '@ngrx/store';
import { ApplicationState, getBizzGuestWifi } from '../../../store/reducers';
import {
  GetWifiSsid,
  UpdateWifiSsid,
} from '../../../store/actions/internet-settings.actions';
import { InternetProduct } from '@dch/products-business-logic';
import { TranslationService } from '@proximus/ng-common';
import { Alert, AlertsService } from '@proximus/ng-common-components';

@Component({
  selector: 'mprd-bizz-guest-wifi',
  templateUrl: './bizz-guest-wifi.component.html',
})
export class BizzGuestWifiComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input() internetProductDetails: InternetProduct;

  @ViewChild('newSsidInput') newSsidInput;

  ssid = '';
  isSsidValid = false;
  isSsidUnavailable = false;

  bizzGuestWifiSsid: string;
  bizzGuestWifiInternalSsid: string;
  bizzGuestWifiHasInvolvement: boolean;
  bizzGuestWifiSsidSucccess: boolean;
  bizzGuestWifiSsidError: boolean;

  newbizzGuestWifiSsid: string;

  constructor(
    private alertService: AlertsService,
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getBizzGuestWifiSsid();
  }

  getBizzGuestWifiSsid() {
    this.store.dispatch(
      new GetWifiSsid(this.internetProductDetails.accessNumber),
    );
    this.addSubscription(
      this.store.select(getBizzGuestWifi).subscribe((value) => {
        this.bizzGuestWifiSsid = value.data.wifiSsid;
        this.bizzGuestWifiInternalSsid = value.data.internalSsid;
        this.bizzGuestWifiHasInvolvement = value.data.hasInvolvement;
        this.bizzGuestWifiSsidSucccess = value.success;
        this.bizzGuestWifiSsidError = value.error;
        this.isSsidUnavailable = false;
        if (this.bizzGuestWifiSsidSucccess || this.bizzGuestWifiSsidError) {
          this.dispatchAlert();
        }
        if (!this.bizzGuestWifiSsid) {
          this.bizzGuestWifiSsid =
            this.translationService.getTranslatedValueFor(
              'bizz.guest.wifi.ssid.get.error',
            );
          this.isSsidUnavailable = true;
        }
      }),
    );
  }

  updateBizzGuestWifiSsid() {
    this.store.dispatch(
      new UpdateWifiSsid({
        accessNumber: this.internetProductDetails.accessNumber,
        wifiSsid: this.ssid,
      }),
    );
    this.reset();
  }

  reset() {
    this.newSsidInput.reset();
    this.ssid = '';
    this.bizzGuestWifiSsidSucccess = false;
    this.bizzGuestWifiSsidError = false;
    this.isSsidUnavailable = false;
  }

  isSsidEmpty() {
    return this.ssid?.length === 0;
  }

  checkMaxSize() {
    return this.ssid?.length <= 20;
  }

  validateSsid() {
    this.isSsidValid =
      !this.isSsidEmpty() && !this.isSsidUnavailable && this.checkMaxSize();
  }

  dispatchAlert() {
    let title: string;
    let description: string;
    let type: 'error' | 'info' | 'success' | 'warning';

    if (this.bizzGuestWifiSsidSucccess) {
      title = this.translationService.getTranslatedValueFor(
        'bizz.guest.wifi.ssid.update.confirmation.label',
      );
      description = this.translationService.getTranslatedValueFor(
        'bizz.guest.wifi.ssid.update.success',
      );
      type = 'success';
    } else if (this.bizzGuestWifiSsidError) {
      title = this.translationService.getTranslatedValueFor(
        'bizz.guest.wifi.ssid.update.error.label',
      );
      description = this.translationService.getTranslatedValueFor(
        'bizz.guest.wifi.ssid.update.error',
      );
      type = 'error';
    }
    const alert: Alert = {
      isClosable: true,
      alertKey: 'updateBizzGuestWifiSsidAlert',
      title,
      description,
      type,
    };
    this.alertService.dispatchAlert(alert);
  }
}
